import React, { useEffect, useState } from 'react'

import {
  Cnpj,
  CustomCheckbox,
  CustomDataTableHeader,
  CustomModal,
  InputText,
  OutlinedBtnPrimary,
} from '../../../../components'
import { errorHandler } from '../../../../services/util/error.service'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { searchClientsByCnpjOrName } from '../../../../services/api/https/registration/client.http'
import { assocAreaClient } from '../../../../services/api/https/picking/picking-area.http'

export default function ModalAreaSeparacaoCliente({
  selectedArea,
  visible,
  onHide,
  onResponse,
  selectedTp,
}) {
  const [area, setArea] = useState(null)
  const [search, setSearch] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [clients, setClients] = useState([])
  const [globalFilter, setGlobalFilter] = useState('')

  useEffect(() => {
    if (selectedArea) {
      setArea(selectedArea)
      setSearch('')
      setClients([])
      setGlobalFilter('')
    }
  }, [selectedArea])

  // Events
  const onBtnPesquisarClick = async () => {
    try {
      setIsLoading(true)
      const fetchedClients = await searchClientsByCnpjOrName(search, selectedTp)
      setClients(fetchedClients)
    } catch (e) {
      onResponse('error', errorHandler(e))
    } finally {
      setIsLoading(false)
    }
  }

  const onBtnSalvarClick = async () => {
    try {
      const selectedClient = clients.find(c => c.selected === true)
      if (!selectedClient) {
        onResponse('error', 'Nenhum cliente foi selecionado')
      } else {
        setIsLoading(true)
        await assocAreaClient(area.id, selectedClient.id)
        onResponse('success', {
          ...area,
          client_id: selectedClient.id,
          client_name: selectedClient.nomeFantasia,
        })
      }
    } catch (e) {
      onResponse('error', errorHandler(e))
    } finally {
      setIsLoading(false)
    }
  }

  const onCheckboxClick = item => {
    setClients(prev => {
      prev.forEach(c => {
        c.selected = c.id === item.id ? !item.selected : false
      })
      return [...prev]
    })
  }

  // Render
  return (
    <CustomModal header="Associação Cliente" width={800} isVisible={visible} onClose={onHide}>
      <div className="p-grid">
        <div className="p-col-12">
          <InputText
            label="Cliente Associado :"
            marginTop={10}
            value={
              area && area.client_id
                ? area.client_id + ' - ' + area.client_name
                : 'Nenhum Cliente associado'
            }
            disabled={true}
          />
        </div>
        <div className="p-col-6">
          <InputText
            label="Pesquisar Cliente :"
            marginTop={10}
            value={search}
            placeholder={'CNPJ, NOME'}
            onChange={value => setSearch(value)}
          />
        </div>
        <div className="p-col-6" style={{ paddingTop: 37 }}>
          <OutlinedBtnPrimary label={'Pesquisar'} onClick={() => onBtnPesquisarClick()} />
          <div style={{ display: 'inline-block', marginLeft: 16 }}>
            <OutlinedBtnPrimary label={'Salvar'} onClick={onBtnSalvarClick} />
          </div>
        </div>
        <div className="p-col-12">
          <DataTable
            loading={isLoading}
            value={clients}
            emptyMessage={'Nenhum cliente encontrado'}
            header={<CustomDataTableHeader onChange={value => setGlobalFilter(value)} />}
            globalFilter={globalFilter}
            rows={5}
            paginator={true}
          >
            <Column
              header={'#'}
              style={{ width: 80, textAlign: 'center' }}
              body={item => (
                <CustomCheckbox checked={item.selected} onChange={() => onCheckboxClick(item)} />
              )}
            />
            <Column field={'id'} header={'Código'} style={{ width: 80, textAlign: 'center' }} />
            <Column field={'nomeFantasia'} header={'Cliente'} />
            <Column
              field={'cnpj'}
              header={'CNPJ'}
              style={{ width: 160, textAlign: 'center' }}
              body={item => <Cnpj>{item.cnpj}</Cnpj>}
            />
          </DataTable>
        </div>
      </div>
    </CustomModal>
  )
}
